// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

// Import Pages
import { Checkboxes, FileInput, TabPanel } from "../../../FlowConfigurationInputs";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";

// Import Material UI
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 2,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #E6E6E6',
        //borderLeft:"6px solid #df7070",
        paddingLeft: 5,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
    },
}))(InputBase);


/**
 * @Description this page OCR Library's Image to Text Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function ImageToText({
    action,
    variables,
    variableRender,
    setOpenVariable,
    automId
}) {
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [value, setValue] = useState(0);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.OCR.";
    const [localType, setLocalType] = useState("");
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                return true;
            },
            fileType: "",
        },
        // checkboxes: { label: label + "TRIM-TEXT" },
    };

    // set localtype initial value
    useEffect(() => {
        if (!action.fields.localType) {
            action.fields.localType = { value: "BASEDONLOCALE" };
            setLocalType('BASEDONLOCALE');
        }
        else {
            setLocalType(action.fields.localType.value)
        }
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };

        } else {
            if (action.fields.fileType.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }
    }, [variables, action])

    // set selected local type
    function handleLocalType(event) {
        const field = initialActionsData[action.id]?.fields.localType;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('localType', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

        setLocalType(event.target.value);
        action.fields.localType.value = event.target.value;
    }

    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = { value: action.fields.filePath.value };
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';

            action.fields.filePath.backupText = { value: action.fields.filePath.value }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        const field = initialActionsData[action.id]?.fields.fileType;
        const oldValue = !field ? undefined : field.value;
        let v = newValue === 1 ? 'TEXT' : 'FILE';
        CheckIfFlowUpdated("fileType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
        setValue(newValue);
    }

    return (
        <div>
            {/* <div className="conf-field-container">
                <FieldLabel name={t(label + 'IMAGE-PATH')} is_required />
                <div className="condition-tabs" style={{ marginBottom: 5 }}>
                    <button
                        className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT-FILE')}
                    </button>
                    <button
                        className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM-STRING')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                    <FileInput action={action} inputName="imagePath" options={options.fileInput} isRequired
                        isSize={true} clear={true} hideRequired />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="imagePath" isRequired={false} setOpenVariable={setOpenVariable}
                        variables={variables} />
                </TabPanel>
            </div> */}
            {/* <div className="conf-field-container">
                <Checkboxes
                    action={action}
                    options={options.checkboxes}
                    inputName="isTrim"
                    isRequired
                />
            </div> */}
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'IMAGE-PATH')} is_required />
                <TextInput action={action} inputName="imagePath" isRequired={true} setOpenVariable={setOpenVariable}
                    variables={variables} hideRequired autom_id={automId} mateDrivePath="filePath" />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "SELECT-LOCALE")} />
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
                    <Select value={localType} onChange={handleLocalType} input={(localType) ? null : <BootstrapInput />}>
                        <MenuItem value="BASEDONLOCALE">{t(label + "BASED-ON-LOCALE")}</MenuItem>
                        <MenuItem value="ENGLISH">{t(label + "ENGLISH")}</MenuItem>

                    </Select>
                </FormControl>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "ASSIGN-VALUE")} is_required />
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    filter="string"
                    isRequired={true}
                    hideRequired
                />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div >
    );
}

export default ImageToText;